module.exports = __webpack_public_path__ + "static/media/auto3n.ee4cd7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/stores/auto3n.png
// module id = 283
// module chunks = 0